// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buildImg[data-v-6b972602]{width:100px;height:100px;margin-right:10px}[data-v-6b972602] .el-descriptions-item__content{font-size:1.01em}.bt[data-v-6b972602]{font-size:16px;color:#606266;margin-top:20px}.bt a[data-v-6b972602]{right:20px;text-align:right;margin-top:-20px;font-size:12px;cursor:pointer;display:block}[data-v-6b972602] .el-dialog__body{overflow:auto!important;height:55vh}.cur-a[data-v-6b972602]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
